import { render, staticRenderFns } from "./returnvisit.vue?vue&type=template&id=1088bb94&scoped=true&"
import script from "./returnvisit.vue?vue&type=script&lang=js&"
export * from "./returnvisit.vue?vue&type=script&lang=js&"
import style0 from "./returnvisit.vue?vue&type=style&index=0&id=1088bb94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1088bb94",
  null
  
)

export default component.exports